/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./dummy.component";
var styles_DummyComponent = [];
var RenderType_DummyComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_DummyComponent, data: {} });
export { RenderType_DummyComponent as RenderType_DummyComponent };
export function View_DummyComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_DummyComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_DummyComponent_0, RenderType_DummyComponent)), i0.ɵdid(1, 49152, null, 0, i1.DummyComponent, [], null, null)], null, null); }
var DummyComponentNgFactory = i0.ɵccf("ng-component", i1.DummyComponent, View_DummyComponent_Host_0, {}, {}, []);
export { DummyComponentNgFactory as DummyComponentNgFactory };
